import { Link } from 'expo-router';
import { StyleSheet, Text, View } from 'react-native';

import { Button } from '@/src/components/Button';
import { PublicPageShell } from '@/src/components/PublicPageShell';
import { MISSION_STATEMENT_PARAGRAPHS } from '@/src/features/changelog/changelog-service';
import { colors } from '@/src/theme/colors';
import { spacing } from '@/src/theme/spacing';

export default function MissionScreen() {
  return (
    <PublicPageShell
      title="Mission Statement"
      subtitle="Frienzzi is built for transparent, positive social connection."
    >
      <View style={styles.card}>
        {MISSION_STATEMENT_PARAGRAPHS.map((paragraph) => (
          <Text key={paragraph} style={styles.paragraph}>
            {paragraph}
          </Text>
        ))}
      </View>
      <Link href="/changelog" asChild>
        <Button title="View public changelog" variant="secondary" />
      </Link>
    </PublicPageShell>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: colors.surface,
    borderColor: colors.border,
    borderRadius: 8,
    borderWidth: 1,
    gap: spacing.lg,
    padding: spacing.xl,
  },
  paragraph: {
    color: colors.text,
    fontSize: 17,
    lineHeight: 26,
  },
});
